/* eslint-disable indent */
import React, { useState, useEffect } from "react";
import {
  Button,
  Modal,
  Radio,
  Space,
  Input,
  message,
  Form,
  Popconfirm,
  Select,
} from "antd";
import { customerOnboardingAPI } from "../api/LeadApi";
import useCustomNavigate from "./customNavigationHook";

const CustomerApprovalAction = ({
  leadDetails,
  navigateTo,
  navigateId,
  setLoading,
  fetchData,
}) => {
  const [nearestCp, setNearestCp] = useState([]);
  const [selectedCp, setSelectedCp] = useState({});

  const [form] = Form.useForm();
  const { TextArea } = Input;
  const navigate = useCustomNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [value, setValue] = useState("option1");
  // eslint-disable-next-line no-unused-vars
  //const [loading, setLoading] = useState(false);
  //const [leadData, setleadData] = useState([]);
  const [inputText, setInputText] = useState(null);

  const rejectList = [
    {
      label: "Conflict with existing CP Network",
      value: "Conflict with existing CP Network",
    },
    {
      label: "Lack of commitment enthusiasm",
      value: "Lack of commitment enthusiasm",
    },
    {
      label: "Failed to pass due diligence check",
      value: "Failed to pass due diligence check",
    },
    {
      label: "Lack of industry experience",
      value: "Lack of industry experience",
    },
    {
      label: "Insufficient financial resources",
      value: "Insufficient financial resources",
    },
    { label: "others", value: "others" },
  ];

  useEffect(() => {
    if (
      leadDetails?.reference === "MARKETING" &&
      leadDetails?.customerType === "CLIENT"
    ) {
      getNearestCp();
    }
  }, [leadDetails]);

  const getNearestCp = async () => {
    const address = leadDetails?.addresses?.find(
      (e) => e?.type === "gstAddress"
    );
    const response = await customerOnboardingAPI.getNearestCpList(
      address?.postalCode || leadDetails?.pincode
    );
    if (response?.status) {
      let data = response?.response?.data?.filter(
        (item) => item?.prospayCustId
      );
      setNearestCp(
        data?.map((item) => ({
          label: item?.aliasCompanyName,
          value: item?.branchId,
          cpId: item?.cpId,
          companyId: item?.branchId,
          prospayCustId: item?.prospayCustId,
        }))
      );
    } else {
      message.error(response?.response?.data?.message);
    }
  };
  const handleCancel = () => {
    setIsModalOpen(false);
    setValue(null);
    setInputText(null);
  };

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = async () => {
    let val = value === "others" ? inputText : value;

    if (val) {
      if (
        leadDetails?.status?.toUpperCase() === "REJECTED" ||
        leadDetails?.status?.toUpperCase() === "APPROVED"
      ) {
        rejectQuotation(val);
        return;
      }
      setLoading(true);
      if (leadDetails?.customerType === "CP") {
        rejectCpLead();
        return;
      }
      let payload = {
        customerId: leadDetails?.customerId,
        approvalStatus: "REJECTED",
        remark: val,
      };
      //let res = await API.Api(`${LEAD_APPROVAL}`).putCustomIdHeader(payload);
      const res = await customerOnboardingAPI.putLead(
        leadDetails?.customerId,
        payload
      );

      if (res?.status) {
        setLoading(false);
        //navigate("/all-approvals", { state: id });
        rejectQuotation(val);
      } else {
        setLoading(false);
        message.error(res?.response?.data?.message || "Internal server error");
        setIsModalOpen(false);
      }
    } else {
      message.error("Please select an option or enter a remark");
    }
  };

  const rejectCpLead = async () => {
    let payload = {
      approvalStatus: "REJECTED",
      approvalStage: pendingApproval.approvalStage,
    };
    const res = await customerOnboardingAPI.approveLeadCP(
      leadDetails?.customerId,
      payload
    );
    if (res?.status) {
      message.success(res?.response?.data?.message);
      navigate(navigateTo, { state: navigateId });
      setIsModalOpen(false);
    } else {
      message.error(res?.response?.data?.message || "Internal server error.");
    }

    // const response = await customerOnboardingAPI.rejectCpLead(
    //   leadDetails?.customerId
    // );
  };

  const rejectQuotation = async (val) => {
    let quotation = leadDetails?.quotations;
    let payload = {
      quotations: quotation?.map((item) => ({
        rateCardType: item.rateCardName,
        rateCardName: item.rateCardType,
        status: "REJECTED",
        remark: val,
      })),
    };
    let response = await customerOnboardingAPI.patchLead(
      leadDetails?.customerId,
      payload
    );
    if (response?.status) {
      navigate(navigateTo, { state: navigateId });
      setIsModalOpen(false);
    } else {
      message.error(
        response?.response?.data?.meessage || "Internal server error."
      );
    }
  };

  // const handleOk = async () => {
  //   let val = value === "others" ? inputText : value;

  //   if (val) {
  //     setLoading(true);
  //     let payload = {
  //       quotations: [
  //         {
  //           rateCardType: rateType,
  //           rateCardName: accountData?.data?.name,
  //           status: "REJECTED",
  //           remark: val,
  //         },
  //       ],
  //     };
  //     let res = await customerOnboardingAPI.patchLead(params?.leadId, payload);
  //     if (res?.status) {
  //       setLoading(false);
  //       navigate("/all-approvals", { state: navigateId });
  //       setIsModalOpen(false);
  //     } else {
  //       setLoading(false);
  //       message.error(res?.response?.data?.message || "Internal server error");
  //       setIsModalOpen(false);
  //     }
  //   } else {
  //     message.error("Please select an option or enter a remark");
  //   }
  // };

  const onRejectChange = (e) => {
    setValue(e.target.value);

    setInputText(null);
  };

  const reRouteToRateCard = async () => {
    // leadDetails?.quotations?.length > 0
    //   ? navigate(
    //       `/lead-cp-approval-confirmation/${leadDetails?.status}/${leadDetails?.customerId}`,
    //       {
    //         state: {
    //           type: "ho-lead",
    //           rateCards: leadDetails?.quotations,
    //           navigateId: navigateId,
    //         },
    //       }
    //     )
    //   : message.error("Rate Card Not Found.");
    setLoading(true);
    let quotation = leadDetails?.quotations;
    let payload = {
      quotations: quotation?.map((item) => ({
        rateCardType: item.rateCardName,
        rateCardName: item.rateCardType,
        status: "APPROVED",
      })),
    };
    //let res = await API.Api(`${LEAD_APPROVAL}`).putCustomIdHeader(payload);
    let response = await customerOnboardingAPI.patchLead(
      leadDetails?.customerId,
      payload
    );
    if (response?.status) {
      setLoading(false);
      message.success(response?.response?.data?.message);
      navigate("/all-approvals", { state: navigateId });
    } else {
      setLoading(false);
      message.error(
        response?.response?.data?.message || "Internal server error."
      );
    }
  };

  const approveLeadCP = async (approvalStage) => {
    let payload = {
      approvalStatus: "APPROVED",
      approvalStage: approvalStage,
    };
    const res = await customerOnboardingAPI.approveLeadCP(
      leadDetails?.customerId,
      payload
    );
    if (res?.status) {
      message.success(
        res?.response?.data?.message || "Lead approved successfully"
      );
      fetchData();
      const allApproved = leadDetails?.approval?.every(
        (item) => item.status === "APPROVED"
      );

      if (allApproved) {
        navigate("/all-approvals", { state: navigateId });
      }
    } else {
      message.error(res?.response?.data?.message || "Internal server error.");
    }
  };

  const approvalStages = ["HO", "ACCOUNT", "LEGAL"];
  const pendingApproval = leadDetails?.approval?.find(
    (item) =>
      approvalStages.includes(item?.approvalStage) && item?.status === "PENDING"
  );

  const approveLead = async () => {
    if (leadDetails?.status?.toUpperCase() === "APPROVED") {
      reRouteToRateCard();
      return;
    }
    if (
      leadDetails?.reference === "MARKETING" &&
      leadDetails?.customerType === "CLIENT"
    ) {
      setLoading(true);
      let payload = {
        customerId: leadDetails?.customerId,
        approvalStatus: "APPROVED",
        companyId: selectedCp?.companyId,
        cpId: selectedCp?.cpId,
        prospayCustId: selectedCp?.prospayCustId,
      };

      const res = await customerOnboardingAPI.putLead(
        leadDetails?.customerId,
        payload
      );

      if (res?.status) {
        setLoading(false);
        message.success(res?.response?.data?.message);
        reRouteToRateCard();
      } else {
        setLoading(false);
        message.error(res?.response?.data?.message || "Internal server error.");
      }
    } else {
      setLoading(true);
      let payload = {
        customerId: leadDetails?.customerId,
        approvalStatus: "APPROVED",
      };
      const res = await customerOnboardingAPI.putLead(
        leadDetails?.customerId,
        payload
      );

      if (res?.status) {
        setLoading(false);
        message.success(res?.response?.data?.message);
        reRouteToRateCard();
      } else {
        setLoading(false);
        message.error(res?.response?.data?.message || "Internal server error.");
      }
    }
  };

  return (
    <>
      {(leadDetails?.status?.toLowerCase() === "pending" ||
        leadDetails?.quotations?.some(
          (e) => e?.status?.toLowerCase() === "pending"
        )) && (
        <>
          {leadDetails?.reference === "MARKETING" &&
          leadDetails?.customerType === "CLIENT" ? (
            <>
              <Button
                className="btn-style cancel-btn ml-1"
                // onClick={cancelTemlate}
                onClick={() => showModal()}
              >
                REJECT
              </Button>
              <Popconfirm
                icon={null}
                //width={400}
                placement="top"
                title={
                  <Form
                    className="global-form"
                    layout="vertical"
                    form={form}
                    scrollToFirstError={{
                      behavior: "smooth",
                      block: "center",
                      inline: "center",
                    }}
                    //onFinish={addMoreCharge}
                  >
                    <Form.Item
                      name="cpList"
                      label="Select CP"
                      rules={[
                        {
                          required: true,
                          message: "Select CP",
                        },
                      ]}
                    >
                      <Select
                        onChange={(val, key) => {
                          setSelectedCp({
                            companyId: key?.companyId,
                            cpId: key?.cpId,
                            prospayCustId: key?.prospayCustId,
                          });
                        }}
                        options={nearestCp}
                        placeholder="Select"
                        style={{ width: "280px" }}
                        showSearch
                        filterOption={(input, option) =>
                          (option?.label ?? "")
                            .toLowerCase()
                            .includes(input.toLowerCase())
                        }
                      />
                    </Form.Item>
                  </Form>
                }
                onConfirm={() => {
                  approveLead();
                }}
                okText="Submit"
                cancelText="CANCEL"
              >
                <Button className="save-btn ml-1">APPROVE</Button>
              </Popconfirm>
            </>
          ) : (
            pendingApproval && (
              <>
                <Button
                  className="btn-style cancel-btn ml-1"
                  // onClick={cancelTemlate}
                  onClick={() => showModal()}
                >
                  REJECT
                </Button>
                <Popconfirm
                  title="Are you sure you want to approve this lead?"
                  onConfirm={() => approveLeadCP(pendingApproval.approvalStage)}
                  okText="Yes"
                  cancelText="No"
                >
                  <Button
                    htmlType="submit"
                    className="save-btn ml-1"
                    id="saveNContinue"
                  >
                    {`${pendingApproval.approvalStage} APPROVE`}
                  </Button>
                </Popconfirm>
              </>
            )
          )}
        </>
      )}

      {/* {leadDetails?.status?.toLowerCase() === "approved" &&
        leadDetails?.quotations?.length > 0 && (
          <Button
            htmlType="submit"
            className="save-btn ml-1"
            onClick={() => reRouteToRateCard()}
          >
            GO TO RATE CARD
          </Button>
        )} */}
      <Modal
        title="Reason for rejection"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        <Radio.Group onChange={onRejectChange} value={value}>
          <Space direction="vertical">
            {rejectList?.map((item, i) => (
              <Radio key={i} value={item.value}>
                {item.label}
              </Radio>
            ))}
          </Space>
        </Radio.Group>
        {value === "others" && (
          <div style={{ marginTop: "20px" }}>
            <div>Remarks</div>
            <TextArea
              className="input-field-style"
              value={inputText}
              onChange={(e) => setInputText(e.target.value)}
              style={{
                borderRadius: "10px",
                minWidth: "250px",
              }}
              placeholder="Please enter remarks"
              autoSize={{
                minRows: 3,
                maxRows: 5,
              }}
            />
          </div>
        )}
      </Modal>
    </>
  );
};
export default CustomerApprovalAction;
